export default __webpack_public_path__ + "static/media/cloudFlare.2dbb3c52.svg";